import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AuthService } from 'src/app/nutrigenic/services/auth/auth.service';
import { JwtTokenService } from 'src/app/nutrigenic/services/auth/jwt-token.service';
import { ResizeDetectionService } from 'src/app/nutrigenic/services/resize-detection.service';
import { OurMenuService } from 'src/app/our-menu.service';
import { AuthDialogService } from 'src/app/nutrigenic/services/auth/auth-dialog.service';
import { HEADER_MENU_ITEMS, MOBILE_MENU_ITEMS } from 'src/app/nutrigenic/constants/menu-items';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
    menuItems: any[] = [];
    selectedItem?: string | null;
    items: MenuItem[] = [];
    items_mobile: MenuItem[] = [];
    isLogin: boolean = false;

    userName: string = 'Login';
    accessToken: string = '';

    isTablet: boolean = false;
    isMobile: boolean = false;
    isDesktop: boolean = false;
    sidebarVisible: boolean = false;

    constructor(
        private router: Router,
        private authService: AuthService,
        private jwtTokenService: JwtTokenService,
        private sizedetection: ResizeDetectionService,
        private ourmenu: OurMenuService,
        private authDialogService: AuthDialogService
    ){}


    ngOnInit(): void {       

        this.sizedetection.refreshSize();
        this.sizedetection.sizeCondition$.subscribe(data => {
            this.isDesktop = data.isDesktop;
            this.isTablet = data.isTablet;
            this.isMobile = data.isMobile;
        });

        this.checkUser();
        this.selectedItem = this.router.url.replace('/', '');
        this.items = HEADER_MENU_ITEMS;
        this.items_mobile = MOBILE_MENU_ITEMS;

        this.router.events.subscribe(event => {
    if (event instanceof NavigationEnd) {
        setTimeout(() => window.scrollTo(0, 0), 100);
    }
});



    }

    showOrderFlowHeader(): boolean {
        const hiddenRoutes = ['order-flow', 'order-summary', 'order-checkout', 'select-meals'];
        return hiddenRoutes.some(route => this.router.url.includes(route));
    }


    handleMenuItemClick(event:any){
        event.preventDefault();
        this.sidebarVisible = !this.sidebarVisible;
    }

    onItemClick(item: any): void {
        this.sidebarVisible = false;
        this.selectedItem = item.url;
        if (item.url != 'home2' && item.url != 'home'){
            this.router.navigate(['/' + item.url]);
        } else if (item.url == 'home') {
            this.selectedItem = '';
            this.router.navigate(['/home']).then(() => {  this.ourmenu.data = 'unset'; });
        } else if (item.url == 'home2') {
            this.selectedItem = '';
            this.router.navigate(['/home']).then(() => {  this.ourmenu.data = 'set'; });
        }
        
    }

    goToHome() {
        this.selectedItem = '';
        this.router.navigate(['/home']);
    }

    goToProfile(): void {
        this.selectedItem = 'profile';
        this.sidebarVisible = false;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/profile'], { queryParams: { id: '6' } });
        });
    }

    goToMyOrders(): void {
        this.selectedItem = 'profile';
        this.sidebarVisible = false;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/profile'], { queryParams: { id: '2' } });
        });
    }

    loginPopupManager() {
        if (this.isLogin) {
            this.router.navigate(['/profile']);
        } else {
            this.authDialogService.openLogin();
        }
    }

    
    checkUser() {
        this.jwtTokenService.getIsLogin().subscribe((data: any) => {
            this.isLogin = data;
            if (this.isLogin) {
                this.userName = this.jwtTokenService.getUserName();
                let first_name = this.userName.substring(0, 1) + ".";
                let last_name = this.userName.substring(this.userName.indexOf(' '), this.userName.length);
                this.userName = first_name + last_name;
            }
        });
    }

    logout() {
        this.authService.logout().subscribe((res:any) => {
            console.log(res);
            localStorage.removeItem('id');
            localStorage.removeItem('expert');
            localStorage.removeItem('profile');
            localStorage.removeItem('token');
            localStorage.removeItem('userName');
            window.location.href = "home";
            window.location.reload();
            this.router.navigate(["home"]);
        });
    }

}
